import { render } from "./CreateTestUser.vue?vue&type=template&id=7de9fbca"
import script from "./CreateTestUser.vue?vue&type=script&lang=js"
export * from "./CreateTestUser.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__